export default "__VITE_ASSET__CWblZbeJ__"